<template>
    <ul class="mainmenu">
				<li><router-link to="/index">首页</router-link></li>
				<li><router-link to="/about">关于我们</router-link></li>
        <li><router-link to="/service">产品服务</router-link></li>
        <li><router-link to="/pricing">产品价格</router-link></li>
        <li><router-link to="/member">会员通道</router-link></li>
        <li><router-link to="/partner">共创伙伴</router-link></li>
        <li><a href="#contact">联系我们</a></li>
    </ul>
</template>

<script>
    import Icon from "../../icon/Icon";
    export default {
        name: 'Nav',
        components: {Icon}
    }
</script>
<style lang="scss" scoped>
	.menulevel1 {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		padding: 28px 50px;
		.lev1-title {
			display: block;
			font-size: 18px;
			color: #444444;
			line-height: 18px;
			font-weight: 800;
			padding-bottom: 12px;
			border-bottom: 1px solid #979797;
		}
		.menu-level2 {
			padding: 8px 0;
			li {
				padding: 8px 0;
				a {
					color: #666;
				}
			}
		}
	}
</style>
